import StipulatorContext from '@philips-emr/hpms-stipulator-commons/lib/contexts/stipulator-context';
import { FetchAPI } from '@philips-emr/tws-components';
import Controller, { OnBeforeFetch, OnMount } from '@philips-emr/tws-core/lib/client';
import { MountEvent } from '@philips-emr/tws-core/lib/component/types';

import BaseController from '../BaseController';

@Controller({ fragment: 'solicitacoes-pendentes-historicos' })
export default class SolicitacoesPendentesHistoricosController extends BaseController {

  @OnMount('panel-solicitacoes-pendentes-historicos')
  onMount(): void {
    const { nrSeqAuditoria } = this.historyService.getCurrentRouteParams();
    this.context.set({ nrSeqAuditoria });
  }

  @OnBeforeFetch('fetch-historicos')
  onBeforeFetchHistoricos(event: MountEvent): void {
    const fetch = event.target as FetchAPI;
    const { nrSeqSubestipulante } = StipulatorContext.getCurrentContract();
    nrSeqSubestipulante && fetch.setParameters({ ...fetch.getParameters(), nrSeqSubestipulante });
  }
}
